const constants = {
    // SEO: hostnames that get noindex meta (Helmet). PropertyHost staging (PBS-10361).
    STAGING_HOSTNAMES: ['online.propertyhost.net'],
    knowledgeBase: 'https://support.propertyboss.com/support/home',
    requestSupport: "https://support.propertyboss.com/support/tickets/new",
    propertyHostClientForWindow: process.env.REACT_APP_PROPERTYBOSS_SOFTWARE_URL,
    forgotPasswordUrl: 'https://propertyhost.propertyboss.net/PropertyHost/',
    portalUrl : process.env.REACT_APP_PORTAL_URL,
    /** Credit Path (Rent Reporting) — external enroll flow; sidebar opens enroll URL only */
    creditPathEnrollUrl: String(process.env.REACT_APP_CREDIT_PATH_ENROLL_URL || '').trim(),
    creditPathLaunchUrl: (() => {
        const launch = String(process.env.REACT_APP_CREDIT_PATH_LAUNCH_URL || '').trim();
        const enroll = String(process.env.REACT_APP_CREDIT_PATH_ENROLL_URL || '').trim();
        return launch || enroll;
    })(),
    /** Marketing / documentation for Credit Path (rent reporting) add-on */
    creditPathLearnMoreUrl:
      process.env.REACT_APP_CREDIT_PATH_LEARN_MORE_URL ||
      "https://support.propertyboss.com/support/home",
    // Message configuration
    MESSAGE_MAX_LENGTH: 6000, // Maximum character count for message content
    // File upload configuration
    MAX_FILES_SELECT_LIMIT: 20, // Maximum number of files user can select/drag at a time
};
export default constants;
